module.exports = __webpack_public_path__ + "static/media/T_logo_rgb_n.10da3240.svg";